
<template>
    <div>
      <div class="flx-center">
      <div class="businessBackground" :style="{ background: 'url(' + $ossUrl + 'images/关于我们.jpg) no-repeat center', backgroundSize: '100%' }"></div>
    </div>
    <div class="footerBottom" style="margin-top: 140px;">
      <div class="container" style="padding-bottom: 70px;">
        <div class="main-title">
            关于美通
        </div>
        <div class="main-content">
            <p>
              美通供应链(AAF)始于2008年，以一站式、一揽子、一条龙的特色运营，提供安全、稳定、快捷的国际物流服务，助力中国制造智达全球。
            </p>
            <p>
              美通渠道产品网络覆盖美国、欧盟、英国、加拿大、墨西哥、日本、澳洲等主要电商贸易国家和地区，强有力的海外团队确保目的港清关配送服务顺畅，提供安全、稳定的海陆空全时效覆盖的多式联运物流解决方案。
            </p>
            <p>
              美通于2023年7月成为信用中国“重点信用认证企业”，2023年8月入选了亚马逊服务提供商网络(Amazon SPN)，2024年2月成为亚马逊ShipTracK服务商，2024年3月成为亚马逊 TSPN服务商、SEND物流承运商，2025年7月成为Temu头程服务商，2025年9月成为亚马逊智能转仓承运商，2025年12月成为亚马逊FIST承运商(Ship Track功能+SR智能转仓服务+DW功能)。
            </p>
            <p>
              2020-2025年连续五届获得晓生排行榜"FBA物流十强企业”，2023年荣获亚马逊“2023金牌辅助”与“SPN一年级奖”等菜誉，2024年荣获雨果跨境“2023最佳跨境物流奖”、物博会“优秀FBA物流服务商”、中国跨境电商物流“十大头程物流服务商”等荣誉，2025年荣获ChinaGo跨境电商“物流阳光守护奖”与“综合赋能阳光守护奖”，中国跨境电商物流“头程物流标杆企业”等荣誉。
            </p>
            <p>
              美通总部位于深圳，办公面积 7000 多平方米，国内在广州、中山、佛山、汕头、惠州、东莞、上海、义乌、郑州、青岛、长沙、合肥、宁波、厦门、成都、杭州、新疆等地设立 30 家分公司，海外在加拿大、美国、墨西哥、英国、比利时、德国、法国、日本、白俄罗斯、越南、哈萨克斯坦等地设立 20 家分公司，全球员工超 1000 人。美通自营线路 80 多条，国内仓储面积 80000 多平方米，自营海外仓面积 100000 多平方米，强大的基础配置与专业团队为多样化物流配送需求提供了保证。
            </p>
            <p>
              美通专注跨境电商物流 10 年，不断完善国内销售网络，扩大产品线覆盖目的国，正着重实现核心市场运营服务完成闭环，信息化向数字化转型，关键运营的控制点基本实现可控和可视化，以成为行业领先的跨境电商物流企业。
            </p>


        </div>
      </div>
     <div style="background: #fff;">
        <div class="container flx-center" style="padding: 70px 0 150px 0 ">
          <video autoplay loop muted playsinline>
             <!-- 视频源，指向你的 mp4 文件 -->
             <source src="https://public-aaf-shenzhen-file.oss-cn-beijing.aliyuncs.com/aaf1.0/ui/media/aboutMT.3bc43ff2.mp4" type="video/mp4">
             Your browser does not support the video tag.
           </video>
            <!-- <div  class="circle4 flx-center">
            <div  class="circle3 flx-center">
              <div  class="circle2 flx-center">
                <div class="circle-container">
                  <div  class="circle"  v-for="(item, index) in buttonProps"
                      :key="index">
                    <div class="circle-item " @click="setBtnActive(item,index)"  :class="[`item${index + 1}`, { 'proprietary-active': activePropsIndex === index}]" :style="{ transform: 'rotate(0deg) translateX(100px) rotate(0deg)' }">{{item.title}}</div>

                  </div>
                </div>
              </div>
           
          </div>
          </div> -->

          <!-- <div style="margin-left: 200px;" v-if="activePropsIndex === 0">
              <img src="@/assets/icons/about/about1.png" alt="">
              <div class="circle-title">一站式</div>
              <div class="circle-content">设立多个分子公司为全国各地客户进行本地化服务</div>
            </div>
            <div style="margin-left: 200px;" v-else-if="activePropsIndex === 1">
              <img src="@/assets/icons/about/about1.png" alt="">
              <div class="circle-title">一揽子</div>
              <div class="circle-content">满足客户多国家、多平台、多产品、多时段的运输要求</div>
            </div>
            <div style="margin-left: 200px;" v-else>
              <img src="@/assets/icons/about/about1.png" alt="">
              <div class="circle-title">一条龙</div>
              <div class="circle-content">以高质量的运营能力实现门到门、端到端服务</div>
            </div> -->
      </div>
     </div>


    <div style="background-color: #000;padding: 55px 0 60px  0 ;">
      <div  class="flx-center">
        <div class="company-title">发展历程</div>
      </div>
    <!-- <div class="flx-center">
      <div id="developYears">
      	<div id="line"></div>
      		<div id="dotList">
      			<div v-for="(item,index) in yearsList" :key="index" :class="item.id==yearsActive?'dot':'dotNo'">
      			<div  class="nullBox"></div>
      			<dl @click="yearsClick(item)">
      				<dt>
      					<img v-show="item.id == yearsActive" :src="$ossUrl+'icons/platform/EllipseWhite.png'" alt="">
      					<img v-show="item.id != yearsActive" :src="$ossUrl+'icons/platform/EllipseBlack.png'" alt="">
      				</dt>
      				<dd>{{item.year}}</dd>
      			</dl>
      		</div>
      	</div>

        
      </div>
    </div> -->
 
    </div>
    <div class="timeline">
      <img :src="$ossUrl+'icons/platform/发展历程.png'" alt="发展历程" />
    </div>
    <!-- <div class="timeline" v-if="yearsActive === 1">
      <div class="timeline-year">
        <div>2023</div>
        <div class="events ">
          <div class="event flx-justify-between"><span>3月</span><span>白俄分公司</span></div>
          <div class="event flx-justify-between"><span>4月</span><span>墨西哥海外仓</span></div>
          <div class="event flx-justify-between"><span></span><span>成立青岛美通</span></div>
          <div class="event flx-justify-between"><span></span><span>挂牌中国整车出口基地</span></div>
          <div class="event flx-justify-between"><span></span><span>成立日本分公司</span></div>
        </div>
      </div>
      <img :src="$ossUrl+'icons/platform/发展历程.png'" alt="">
      <div class="timeline-year">
        <div>2022</div>
        <div class="events ">
          <div class="event flx-justify-between"><span>9月</span><span>投资新疆阿拉山口</span></div>
          <div class="event flx-justify-between"><span>10月 </span><span>加拿大海外仓</span></div>
          <div class="event flx-justify-between"><span>12月</span><span>比利时分公司</span></div>
        </div>
      </div>
      <div class="timeline-year">
        <div>2021</div>
        <div class="events ">
          <div class="event flx-justify-between"><span>4月</span><span>美国洛杉矶海外仓</span></div>
          <div class="event flx-justify-between"><span>5月</span><span>成立佛山美通</span></div>
          <div class="event flx-justify-between"><span></span><span>美国纽约海外仓</span></div>
          <div class="event flx-justify-between"><span>8月</span><span>成立东莞美通</span></div>
          <div class="event flx-justify-between"><span>10月</span><span>比利时海外仓</span></div>
        </div>
      </div>
      <div class="timeline-year">
        <div>2020</div>
        <div class="events ">
          <div class="event flx-justify-between"><span>1月</span><span>成立义乌美通</span></div>
          <div class="event flx-justify-between"><span>7月</span><span>成立广州美通</span></div>
          <div class="event flx-justify-between"><span>8月</span><span>英国海外仓</span></div>
        </div>
      </div>
    </div> -->
    <!-- <div class="timeline" v-else-if="yearsActive === 2">
      <div class="timeline-year">
        <div>2019</div>
        <div class="events ">
          <div class="event flx-justify-between"><span>9月</span><span>成立龙华分部</span></div>
          <div class="event flx-justify-between"><span>7月</span><span>成立上海美通</span></div>
        </div>
      </div>
      <div class="timeline-year">
        <div>2018</div>
        <div class="events ">
          <div class="event flx-justify-between"><span>11月</span><span>成立中山美通</span></div>
        </div>
      </div>
      <div class="timeline-year">
        <div>2016</div>
        <div class="events ">
          <div class="event flx-justify-between"><span>3月</span><span>成立机场分部</span></div>
        </div>
      </div>
    </div> -->
    <!-- <div class="timeline" v-else-if="yearsActive === 3">
      <div class="timeline-year">
        <div>2015</div>
        <div class="events ">
          <div class="event flx-justify-between"><span>12月</span><span>更名为美通</span></div>
        </div>
      </div>
    </div> -->
    <!-- <div class="timeline" v-else-if="yearsActive === 5">
      <div class="timeline-year">
        <div>2008</div>
        <div class="events ">
          <div class="event flx-justify-between"><span></span><span>深圳创立AAF</span></div>
        </div>
      </div>
    </div> -->
    <!-- <div class="container" style="margin-top: 140px;margin-bottom: 70px;"> -->
        <!-- <div class="main-title">美通媒体平台</div> -->
        <!-- <div class="flx-justify-around" style="margin-top: 72px;">
          <div>
            <img src="@/assets/images/platform/publicAccount.png" alt="">
            <div style="text-align:center;font-size: 20px;color: #151E2C;font-weight: 500;margin-top:17px">美通公众号</div>
          </div>
          <div>
            <img src="@/assets/images/platform/videoQrcode.png" alt="">
            <div style="text-align:center;font-size: 20px;color: #151E2C;font-weight: 500;margin-top:17px">美通视频号</div>
          </div>
          <div >
            <img style="border:1px dashed #A7A7A7;width:190px;height:190px;padding:15px" src="@/assets/images/platform/tiktokQrcode.png" alt="">
            <div style="text-align:center;font-size: 20px;color: #151E2C;font-weight: 500;margin-top:17px">美通抖音号</div>
          </div>
          <div>
            <img style="border:1px dashed #A7A7A7;width:190px;height:190px;padding:15px" src="@/assets/images/platform/redBook.png" alt="">
            <div style="text-align:center;font-size: 20px;color: #151E2C;font-weight: 500;margin-top:17px">美通小红书</div>
          </div>
        </div> -->
    <!-- </div> -->
    </div>
    </div>
  </template>
  <script>
  
  
  /**
   * Index-1 component
   */
  export default {
      name:"about",
    components: {
    },
    data(){
      return {
        activeName: 'second',
        activeIndex: 2, // 默认选中第一个按钮
        buttons: [
          { label: '关于美通',transportMode:'OCEAN' },
          { label: '联系我们',transportMode:'AIR' },
          { label: '企业文化',transportMode:'RAIL' },
          { label: '企业招聘',transportMode:'ROAD' }
        ],
        activePropsIndex:0,
        buttonProps: [
          { title: '一站式',capital:'温哥华/多伦多'},
          { title: '一揽子',capital:'洛杉矶/芝加哥'}, 
          { title: '一条龙',capital:'墨西哥'},
        ],
        yearsActive:1,
				yearsList:[
					{
						id:1,
						year:'2023',
						value:''
					},
					{
						id:2,
						year:'2019',
						value:''
					},
					{
						id:3,
						year:'2015',
						value:''
					},
					{
						id:4,
						year:'2011',
						value:''
					},
					{
						id:5,
						year:'2008',
						value:''
					}
				]
      }
    },
    methods: {
      handleClick(tab, event) {
          console.log(tab, event);
        },
        yearsClick(row){
        	this.yearsActive = row.id;
        },
        setBtnActive(item,index){
          this.activePropsIndex = index;
        },
      setActive(item,index) {
        if(index === 1){
          this.$router.push({
            name:'connection'
          })
        }else if(index === 2){
          this.$router.push({
            name:'corporateCulture'
          })
        }else if(index === 3){
          this.$router.push({
            name:'inviteJob'
          })
        }else {
          this.$router.push({
            name:'about'
          })
        }
        // this.activeIndex = index;
        
  
      },
    }
  };
  </script>
  <style src="../index.css" scoped></style>